// extracted by mini-css-extract-plugin
module.exports = {"all":"File_all__gqvq6","footer":"File_footer__1-p0n","link":"File_link__191lW"};